import NotificationResource from '@/resources/NotificationResource';

export default class Notification {
    constructor() {
        this.Resource = new NotificationResource()
    }

    async getNumber() {
        const notification = await this.Resource.getNumber()
        return notification.data
    }

    async getWarning() {
        const warning = await this.Resource.getWarning()
        return warning.data
    }

    async getUnread() {
        const unread = await this.Resource.getUnread()
        return unread.data
    }

    async read() {
        const notification = await this.Resource.read()
        return notification.data
    }
}